var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutstandingAmountKpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.9868 34.5264C39.9868 38.3591 37.135 41.2899 33.4057 41.2899C28.9694 41.2899 27.3236 37.9604 26.9265 34.2685C26.8084 33.1703 25.9291 32.2719 24.8245 32.2719H9.27485H2.5C1.39543 32.2719 0.4839 33.1703 0.602003 34.2685C0.999025 37.9604 2.64487 41.2899 7.08114 41.2899H33.4057",
    fill: "#F2CA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.4057 41.29C28.9694 41.29 27.3236 37.9605 26.9265 34.2686C26.8084 33.1703 25.9291 32.272 24.8245 32.272H9.27485H2.5C1.39543 32.272 0.4839 33.1703 0.602003 34.2686C0.999025 37.9605 2.64487 41.29 7.08114 41.29H33.4057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.27539 32.2719V2.70898C9.27539 1.60442 10.1708 0.708984 11.2754 0.708984H37.9874C39.0919 0.708984 39.9874 1.60442 39.9874 2.70898V34.5264",
    fill: "#F2CA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250539",
    d: "M39.9999 30.0181H22.4355L26.2019 32.9037L27.8252 38.3146L30.5306 41.0201L34.501 41.2906L39.9852 36.7816L39.9999 30.0181Z",
    fill: "#F2CA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M39.9873 11.9806V34.5255",
    stroke: "#383434",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.9868 34.5255C39.9868 38.3581 37.135 41.289 33.4057 41.289C28.9694 41.289 27.3236 37.9595 26.9265 34.2676C26.8084 33.1694 25.9291 32.271 24.8245 32.271H2.5C1.39543 32.271 0.4839 33.1694 0.602003 34.2676C0.999025 37.9595 2.64486 41.289 7.08114 41.289H33.4057",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M39.9868 34.5254C39.9868 38.358 37.135 41.2889 33.4057 41.2889M33.4057 41.2889H7.08114C2.64486 41.2889 0.999025 37.9594 0.602003 34.2675C0.4839 33.1692 1.39543 32.2709 2.5 32.2709H24.8245C25.9291 32.2709 26.8084 33.1692 26.9265 34.2675C27.3236 37.9594 28.9694 41.2889 33.4057 41.2889Z",
    stroke: "#383434",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31.214 14.2351H18.0518",
    stroke: "#383434",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M31.214 23.2539H18.0518",
    stroke: "#383434",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250704",
    d: "M36.4824 32.9039L39.4243 33.9896C39.4243 33.9896 39.5822 35.2533 39.0906 36.7127C38.7935 37.5945 38.2454 38.4673 37.618 39.041C37.5904 39.0663 37.5535 39.1162 37.5223 39.1476C37.3787 39.2919 37.1879 39.4783 36.7784 39.7349C36.3121 40.0574 35.6883 40.3985 34.8718 40.5722C34.5669 40.6469 34.1557 40.7307 33.8741 40.7286C33.1606 40.7233 32.6947 40.4792 32.6947 40.4792L29.9893 34.5272L36.4824 32.9039Z",
    fill: "#F2CA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutstandingAmountKpi);
export default __webpack_public_path__ + "static/media/outstanding_Amount_KPI.62983863a6de8221e31db21e33bc90e8.svg";
export { ForwardRef as ReactComponent };